<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14B0IO7/tc-custom/9780802191328.jpg?1726519033186" alt="This image is the cover for the book House Rivals, The Joe DeMarco Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">House Rivals, The Joe DeMarco Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>In this “suspenseful and smart” thriller, Washington, DC, heavy hitter Joe DeMarco is out of town—and out of his element—facing his deadliest enemy yet (<i>Booklist</i>).</b><br/>  <br/><b>Author of <i>House Witness</i>, 2019 Edgar Award Finalist for Best Novel</b><br/><br/> Working behind the scenes in the nation’s capital, Joe DeMarco knows how to repay a debt. But now he’s repaying a debt owed by his boss—Minority Leader John Mahoney. Years ago, a man saved Mahoney’s life in Vietnam. Now, that man’s granddaughter, Sarah, is in dire need of help.<br/>  <br/> Sarah has been battling against a billionaire oil tycoon with her online blog, trying to prevent him from despoiling any more of her beloved North Dakota landscape. Now she’s being threatened and physically assaulted by the tycoon’s hired muscle—and DeMarco is the only one who can protect her.<br/>  <br/> But as DeMarco tracks his adversaries in the unfamiliar territory, the situation turns unexpectedly violent, and the fixer finds himself in a battle against a pair of ruthless corporate “problem solvers” who will stop at nothing to take Sarah and DeMarco out for good.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Lawson
      </h2>
      
      <p class="authorDescription body article">Mike Lawson is a former senior civilian executive for the US Navy. He is the author of eleven previous novels starring Joe DeMarco and three novels with his protagonist Kay Hamilton.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atlantic Monthly Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7aac3996